 document.getElementById("submit-btn").addEventListener("click", function(event) {
    var name = document.getElementById("ContactForm-name").value;
    var email = document.getElementById("ContactForm-email").value;
    var phone = document.getElementById("ContactForm-phone").value;
    var comment = document.getElementById("ContactForm-body").value;
    
    var url = "https://script.google.com/macros/s/AKfycbxfN6brpw8RS14SSFs7rjidTb21PgMXE0LBv_QokL-thtvJ_f51aTP7J24SwAx5CjJM/exec"
      + "?name=" + encodeURIComponent(name)
      + "&email=" + encodeURIComponent(email)
      + "&phone=" + encodeURIComponent(phone)
      + "&comment=" + encodeURIComponent(comment);
   
    fetch(url)
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        console.log(data);
      })
      .catch(function(error) {
        console.log(error);
      });
  });